module.exports = __webpack_public_path__ + "static/SacKings-NBA-494e1d85cc2e083f366237ee728b4d99.png";